// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kvr1","footer":"styles_footer__2LjD9"};